package com.eladfinish.bible.contest.screens.americanQuestions.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.downloading_data_format
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsAction
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsState
import com.eladfinish.bible.contest.screens.search.ui.dialogs.LoadingMessageDialog
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType
import dev.icerock.moko.resources.format

@Composable
fun AmericanQuestionsDialogs(
    dialogState: AmericanQuestionsState.DialogState,
    onAction: (AmericanQuestionsAction) -> Unit,
) {
    when (dialogState) {
        AmericanQuestionsState.DialogState.None -> Unit

        is AmericanQuestionsState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = HelpContentType.Raw(dialogState.content),
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = {
                    onAction(AmericanQuestionsAction.ToggleHelp(shouldShowNextTime = it))
                },
                onDismiss = {
                    onAction(AmericanQuestionsAction.HideDialog)
                },
            )
        }

        AmericanQuestionsState.DialogState.DownloadingQuestions -> {
            LoadingMessageDialog(
                onDismiss = {
                    onAction(AmericanQuestionsAction.HideDialog)
                },
                sentence = SharedRes.strings.downloading_data_format.format("..."),
            )
        }
    }
}
